'use client'

import { useContext, useEffect, useRef } from "react"
import { streamTabsType, useLiveStreamContext } from "../_config"
import { DeviceContext } from "@/context/deviceContext"

import icon_1 from "@/public/icon/muti_1.png"
import icon_2 from "@/public/icon/muti_2.png"
import icon_4 from "@/public/icon/muti_4.png"
import { useTranslations } from "next-intl"

export default function SportsLiveTabs() {
    const { streamLen, setStreamLen } = useLiveStreamContext()
    const { mobileMode } = useContext(DeviceContext)
    
    const t = useTranslations('Text')

    const tabsRef = useRef<HTMLUListElement>(null)

    useEffect(() => {
        if(mobileMode){
            tabsRef.current?.style.setProperty('--col', `2`);
        }else{
            tabsRef.current?.style.setProperty('--col', `3`);
        }        
    }, [mobileMode])

    const tabs = [
        { name: "싱글채널", tab: 1, callBack: () => { setStreamLen(1) }, icon: icon_1.src  },
        { name: "멀티채널 2", tab: 2, callBack: () => { setStreamLen(2) }, icon: icon_2.src  },
        { name: "멀티채널 4", tab: 4, callBack: () => { setStreamLen(4) }, icon: icon_4.src  },
    ]
    return (
        <div className="page-tabs">
            <ul ref={tabsRef} className={`sub-page`}>
                {
                    tabs.map(({ name, tab, icon, callBack }, index) => {
                        if(mobileMode && index > 1){
                            return null;
                        }else{
                            return (
                                <li key={index}
                                    className={tab == streamLen ? "active" : ""}
                                    onClick={e => callBack()} >
                                        <p>{t(name)}</p>
                                        <img src={icon} alt="icon" className="muti-icon" />
                                    </li>
                            )
                        }
                    })
                }
            </ul>
        </div>
    )
}